import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import type { PlatformLimits } from 'components/ValidationBanner/utils'

interface UsePostValidationProps {
  errors: string[]
  provider?: ExternalIntegrationEnum
}

interface UsePostValidationResult {
  characterLimitErrors: string[]
  otherErrors: string[]
  selectedPlatform?: PlatformLimits
}

export const usePostValidation = ({ errors, provider }: UsePostValidationProps): UsePostValidationResult => {
  const characterLimitErrors = errors.filter(
    (error) => error.includes('Content exceeds') && error.includes('characters'),
  )
  const otherErrors = errors.filter((error) => !error.includes('Content exceeds') || !error.includes('characters'))

  const getSelectedPlatform = (provider: ExternalIntegrationEnum): PlatformLimits | undefined => {
    switch (provider) {
      case ExternalIntegrationEnum.Instagram:
        return 'instagram'
      case ExternalIntegrationEnum.LinkedIn:
        return 'linkedin'
      case ExternalIntegrationEnum.Facebook:
        return 'facebook'
      case ExternalIntegrationEnum.X:
        return 'x'
      default:
        return undefined
    }
  }

  const selectedPlatform = provider ? getSelectedPlatform(provider) : undefined

  return {
    characterLimitErrors,
    otherErrors,
    selectedPlatform,
  }
}
